import { render } from "./adminthree.vue?vue&type=template&id=586c82fb&scoped=true"
import script from "./adminthree.vue?vue&type=script&lang=js"
export * from "./adminthree.vue?vue&type=script&lang=js"

import "./adminthree.vue?vue&type=style&index=0&id=586c82fb&scoped=true&lang=css"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586c82fb"]])

export default __exports__